import React from 'react'

import { Link } from '@toptal/picasso'

interface IProps {
  text: string
  type: string
  onClick(type: string): void
}

const ExampleDataLink: React.FunctionComponent<IProps> = props => {
  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault()

    props.onClick(props.type)
  }
  return (
    <Link tabIndex={0} onClick={handleClick}>
      {props.text}
    </Link>
  )
}

export default ExampleDataLink
